/* eslint-disable indent */
import { Text } from '@chakra-ui/react'

export default function CategoryTitle({ category }: { category: string }) {
  switch (category.toUpperCase()) {
    case 'ADJUSTMENTS':
      return (
        <Text fontWeight="bold" fontSize="md">
          🛠️ Ajustes
        </Text>
      )

    case 'ADVERTISEMENT':
      return (
        <Text fontWeight="bold" fontSize="md">
          📣 Anúncios
        </Text>
      )

    case 'FEATURE':
      return (
        <Text fontWeight="bold" fontSize="md">
          🚀 Recursos
        </Text>
      )

    case 'FIX':
      return (
        <Text fontWeight="bold" fontSize="md">
          🐞 Correções
        </Text>
      )

    default:
      return <></>
  }
}
